<template lang="pug">
    .loading
      .loading__left
      .loading__right
      .loading__clap
        .loading__images
          img.loading__carrot(src="@/assets/images/beyond-image-carrot.png" alt="Instacart logo" width="90" height="89")
          #lottie-loading
          //img(src="@/assets/images/clapping-crop.gif" alt="Clapping")        
        .loading__title
          h2 Loading#[span.dot .] #[span.dot .] #[span.dot .]
</template>
<script>
import { gsap } from 'gsap'
import lottie from 'lottie-web'
//import svgLottie from '@/assets/images/clapping.json'
export default {
    props:{
      
    },
    mounted(){
        this.animations()
    },
    methods:{
        animations: function(){
            const animClapping = {
              container: document.getElementById('lottie-loading'),
              renderer: 'svg',
              loop: true,
              autoplay: true,
              path: 'clapping.json',
              // Path for production //
               // path: '/blog-nubank/wp-content/themes/nubankv2/quiz/animations/lamp.json'
            }
            lottie.loadAnimation(animClapping)
          
            gsap.to('.dot',{repeat:-1, alpha:0,repeatDelay:0, duration:1, stagger:0.2, opacity:1, ease:'Power3.easeOut', yoyoEase:true})
        },
    }
}
</script>
<style lang="scss" scoped>
    .loading{
        height: 100vh;
        width: 100vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 9999;
        &__left, &__right{
          background:$soft_brown;
          position: absolute;
          width: 50%;
          height: 100%
        }
        &__left{
          top: 0;
          left: 0;
        }
        &__right{
          top: 0;
          left: 50%;
        }
        &__clap{
          position: relative;
          z-index: 2;
          flex-shrink: 0;
          img:not(.loading__carrot){
            width: 170px;
            @include respond-to('small'){
              width: 200px;
            }
          }
        }
        &__images{
          display: flex;
            #lottie-loading{
              width: 180px;
            }
          
        }
        &__carrot{
          position: absolute;
          width: 70px;
          height: 69px;
          left: -10px;
          top: 30px;
          @include respond-to('small'){
            width: 90px;
            height: 89px;
            left: -20px;
            top: 30px;
          }
        }
        &__title{
            text-align: center;
            position: relative;
            h2{
                color: $green;
                font-weight: normal;
                margin: 0;
            }
            .dot{
                margin: 0;
                letter-spacing: -0.18em;
                display: inline-block;
            }
        }
    }
</style>
